import { reactive, ref } from 'vue';

/** Flag for whether we are in clipping mode. */
export const clipping_on = ref(false);

/** Flag for whether the model can be edited while clipping. */
export const clipping_model_editable = ref(false);

export const section_planes_active = () => clipping_on.value || clipping_model_editable.value;

/** start and end positions of the clipping planes */
export const clipping_planes = reactive({
    xy: {
        max: 0,
        min: 0,
    },

    yz: {
        max: 0,
        min: 0,
    },

    xz: {
        max: 0,
        min: 0,
    },
});
